import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" I strongly believe that contributing to open source projects and actively engaging with the software community is an excellent approach to both learning and assisting others. ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Listed below are some of the projects I have created and actively contribute to: ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Mathema ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" github.com/ceotrammell/mathema ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" My aim with this open source project is to apply the math-related use cases I have learned and provide convenient access to its functionality for everyone in a NodeJS environment. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ionic Pick ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" github.com/ceotrammell/ionic-pick ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" This project is to apply an better option with ion-item's for everyone in a Ionic Angular environment. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_card, { class: "home-header-sub-ion-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_content, { class: "aboutmecomponent-sub-ion-card-content" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_card, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goToSite('https://github.com/ceotrammell/mathema')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_title, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_ion_icon, {
                  icon: $setup.chevronForwardOutline,
                  class: "ion-card-arrows"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card_subtitle, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_card_content, null, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_card, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToSite('https://github.com/ceotrammell/ionic-pick')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_title, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_ion_icon, {
                  icon: $setup.chevronForwardOutline,
                  class: "ion-card-arrows"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card_subtitle, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_card_content, null, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}